import { BnumConfig } from './BnumConfig';
import { LogEnum } from './LogEnum';

export default class Log {
  static trace(context: string, ...args: any[]): void {
    if (
      BnumConfig.Get('console_logging') &&
      BnumConfig.Get('console_logging_level')! <= LogEnum.TRACE
    )
      console.trace(`[${context}]`, ...args);
  }

  static debug(context: string, ...args: any[]): void {
    if (
      BnumConfig.Get('console_logging') &&
      BnumConfig.Get('console_logging_level')! <= LogEnum.DEBUG
    )
      console.debug(`🔎 [${context}]`, ...args);
  }

  static info(context: string, ...args: any[]): void {
    if (
      BnumConfig.Get('console_logging') &&
      BnumConfig.Get('console_logging_level')! <= LogEnum.INFO
    )
      console.info(`ℹ️ [${context}]`, ...args);
  }

  static warn(context: string, ...args: any[]): void {
    if (
      BnumConfig.Get('console_logging') &&
      BnumConfig.Get('console_logging_level')! <= LogEnum.WARN
    )
      console.warn(`⚠️ [${context}]`, ...args);
  }

  static error(context: string, ...args: any[]): void {
    if (
      BnumConfig.Get('console_logging') &&
      BnumConfig.Get('console_logging_level')! <= LogEnum.ERROR
    )
      console.error(`### [${context}]`, ...args);
  }

  static time(label: string): void {
    if (
      BnumConfig.Get('console_logging') &&
      BnumConfig.Get('console_logging_level')! <= LogEnum.DEBUG
    )
      console.time(label);
  }

  static timeEnd(label: string): void {
    if (
      BnumConfig.Get('console_logging') &&
      BnumConfig.Get('console_logging_level')! <= LogEnum.DEBUG
    )
      console.timeEnd(label);
  }
}
